"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "message-container"
  }, [!_vm.isMobile ? _c("div", {
    staticClass: "message-box"
  }, [_c("div", {
    staticClass: "m-flex-col",
    staticStyle: {
      flex: "1",
      "margin-right": "30px"
    }
  }, [_vm._m(0), _c("div", {
    staticClass: "info",
    staticStyle: {
      flex: "1",
      "font-size": "20px",
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_c("p", [_vm._v(_vm._s(_vm.message.enterpriseName))]), _c("p", [_vm._v("姓名：" + _vm._s(_vm.message.name))]), _c("p", [_vm._v("手机：" + _vm._s(_vm.message.mobile))]), _c("p", [_vm._v("职位：" + _vm._s(_vm.message.title))])])]), _c("img", {
    staticStyle: {
      height: "180px",
      width: "150px",
      "margin-top": "40px"
    },
    attrs: {
      src: _vm.message.avatar || require(`@/assets/images/avatar.png`)
    }
  })]) : _c("div", {
    staticClass: "mobile-box"
  }, [_c("img", {
    staticStyle: {
      width: "50vw",
      height: "30vw"
    },
    attrs: {
      src: require("@/assets/icons/yskc.svg")
    }
  }), _c("img", {
    staticStyle: {
      width: "50%",
      height: "50vw",
      "margin-bottom": "10vw"
    },
    attrs: {
      src: _vm.message.avatar || require(`@/assets/images/avatar.png`)
    }
  }), _c("div", {
    staticClass: "info"
  }, [_c("p", [_vm._v(_vm._s(_vm.message.enterpriseName))]), _c("p", [_vm._v("姓名：" + _vm._s(_vm.message.name))]), _c("p", [_vm._v("手机：" + _vm._s(_vm.message.mobile))]), _c("p", [_vm._v("职位：" + _vm._s(_vm.message.title))])])]), !_vm.isMobile ? _c("img", {
    staticStyle: {
      width: "300px",
      "margin-left": "30px"
    },
    attrs: {
      src: _vm.qrCodeData,
      alt: "QR Code"
    }
  }) : _vm._e()]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "m-flex m-row-center",
    staticStyle: {
      width: "100%"
    }
  }, [_c("img", {
    staticStyle: {
      height: "50px"
    },
    attrs: {
      src: require("@/assets/icons/yskc.svg")
    }
  })]);
}];
render._withStripped = true;